import "./BasicHomepage.css";
import instagramIcon from "../../../../../../icons/instagram.png"
import facebookIcon from "../../../../../../icons/facebook.png";
import twitterIcon from "../../../../../../icons/twitter.png";
import youtubeIcon from "../../../../../../icons/youtube.png";
import emailIcon from "../../../../../../icons/email.png";

function normalizeHref(value = "") {
  const v = value.trim();
  if (!v) return "";

  if (
    v.startsWith("http://") ||
    v.startsWith("https://") ||
    v.startsWith("mailto:") ||
    v.startsWith("tel:")
  ) {
    return v;
  }

  if (v.includes("@") && !v.includes(" ")) {
    return `mailto:${v}`;
  }

  return `https://${v}`;
}

function BasicHomepage({ organization, page, settings }) {
  const org = organization || {};
  const content = page?.content || {};
  const theme = settings || {};

  const orgName = org.name?.trim() || "Your Organization";
  const heroPrefix = "Welcome to";
  const heroTitle =
    content.title?.trim() ||
    orgName;

  const metaSport = content.meta_sport?.trim() || "";
  const metaLocation = content.meta_location?.trim() || "";
  const shortText = content.headline?.trim() || "";

  const registrationLabel = content.registration_label?.trim() || "Register Now";
  const registrationUrl = normalizeHref(content.registration_url || "");

  const instagramUrl = normalizeHref(org.instagram_url || "");
  const facebookUrl = normalizeHref(org.facebook_url || "");
  const twitterUrl = normalizeHref(org.twitter_url || "");
  const youtubeUrl = normalizeHref(org.youtube_url || "");
  const contactEmail = org.contact_email?.trim() || "";

  const coverUrl = content.cover_url || "";


  const themeMode =
    String(theme.theme_mode || "dark").trim().toLowerCase() === "light"
      ? "light"
      : "dark";

  const textColor = themeMode === "light" ? "#111111" : "#ffffff";
  const backgroundColor = themeMode === "light" ? "#ffffff" : "#000000";

  const primaryColor = theme.primary_color || "#1f3b73";
  const accentColor = theme.accent_color || "#f28c38";



  const hasAnyLink =
    instagramUrl ||
    facebookUrl ||
    twitterUrl ||
    youtubeUrl ||
    contactEmail;

  return (
    <div
      className={`basic-homepage ${themeMode}`}
      style={{
        "--bh-primary": primaryColor,
        "--bh-accent": accentColor,
        "--bh-text": textColor,
        "--bh-bg": backgroundColor,
      }}
    >
      <section className="bh-shell">
        <section className="bh-panel">
          <div className="bh-inner">
            <div className="bh-left">

              <div className="bh-copy">
                <h1>
                  <span className="bh-title-prefix">{heroPrefix}</span>
                  <span className="bh-title-main">{heroTitle}</span>
                </h1>

                {metaSport || metaLocation ? (
                  <div className="bh-meta">
                    {metaSport ? <span className="bh-meta-sport">{metaSport}</span> : null}

                    {metaSport && metaLocation ? <span className="bh-meta-dot">•</span> : null}

                    {metaLocation ? (
                      <span className="bh-meta-location">
                        <span>{metaLocation}</span>
                      </span>
                    ) : null}
                  </div>
                ) : null}

                {shortText ? <p className="bh-short-text">{shortText}</p> : null}

                {registrationUrl ? (
                  <div className="bh-hero-actions">
                    <a
                      href={registrationUrl}
                      target="_blank"
                      rel="noreferrer"
                      className="bh-primary-btn"
                    >
                      {registrationLabel}
                    </a>
                  </div>
                ) : null}

                <div className="bh-social-row">

                  {facebookUrl ? (
                    <a href={facebookUrl} target="_blank" rel="noreferrer" aria-label="Facebook">
                      <img src={facebookIcon} alt="" className="bh-social-icon" />
                    </a>
                  ) : null}
                  {instagramUrl ? (
                    <a href={instagramUrl} target="_blank" rel="noreferrer" aria-label="Instagram">
                      <img src={instagramIcon} alt="" className="bh-social-icon bh-social-icon-instagram" />
                    </a>
                  ) : null}
                  {twitterUrl ? (
                    <a href={twitterUrl} target="_blank" rel="noreferrer" aria-label="X / Twitter">
                      <img src={twitterIcon} alt="" className="bh-social-icon" />
                    </a>
                  ) : null}

                  {youtubeUrl ? (
                    <a href={youtubeUrl} target="_blank" rel="noreferrer" aria-label="YouTube">
                      <img src={youtubeIcon} alt="" className="bh-social-icon" />
                    </a>
                  ) : null}


                  {contactEmail ? (
                    <a href={`mailto:${contactEmail}`} aria-label="Email">
                      <img src={emailIcon} alt="" className="bh-social-icon" />
                    </a>
                  ) : null}

                  {!hasAnyLink ? <span className="bh-empty-inline">Links coming soon.</span> : null}
                </div>
              </div>
            </div>

            <div className="bh-right">
              <div className="bh-shape bh-shape-back" />
              <div className="bh-shape bh-shape-front" />

              {coverUrl ? (
                <img src={coverUrl} alt={heroTitle} className="bh-cover-image" />
              ) : (
                <div className="bh-cover-placeholder" />
              )}
            </div>
          </div>
        </section>
      </section>
    </div>
  );
}

export default BasicHomepage;